/**
 * Docs: https://redux-toolkit.js.org/api/configureStore
 *
 *  next-redux-wrapper: https://github.com/kirill-konshin/next-redux-wrapper
 */

// import type { CombinedState } from '@reduxjs/toolkit';
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import type { Context } from 'next-redux-wrapper';
import { createWrapper } from 'next-redux-wrapper';

import { highlighterApi } from '@highlight-cp/highlighter-api';
import { projectApi } from '@highlight-cp/project-api';
import { projectOrchestratorApi } from '@highlight-cp/project-orchestrator-api';
import { surveyApi } from '@highlight-cp/survey-api';
import { sessionRecheckMiddleware } from 'auth/sessionRecheck';
import reducer from 'store/reducer';
import { rtkQueryErrorLogger } from 'store/rtkQueryErrorLogger';

let _store: AppStore;

const makeStore = (_context: Context) => {
  const tempStore = configureStore({
    reducer,

    middleware: (getDefaultMiddleware) => {
      return (
        getDefaultMiddleware({
          thunk: { extraArgument: {} },
        })
          // First, as the RTK listener guide asks: before the serializability check.
          .prepend(sessionRecheckMiddleware)
          .concat(projectApi.middleware)
          .concat(projectOrchestratorApi.middleware)
          .concat(highlighterApi.middleware)
          .concat(surveyApi.middleware)
          .concat(rtkQueryErrorLogger)
      );
    },
  });

  setupListeners(tempStore.dispatch);
  _store = tempStore;

  return tempStore;
};

// needed to bypass '$CombinedState' from external module error
// tsconfig declaration: false fixes this too
// type CleanState<T> = T extends CombinedState<infer S> ? { [K in keyof S]: CleanState<S[K]> } : T;

export type AppStore = ReturnType<typeof makeStore>;
// export type RootState = CleanState<ReturnType<AppStore['getState']>>;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];

export const reduxWrapper = createWrapper<AppStore>(makeStore, {
  debug: false, //process.env.NODE_ENV === "development",
});

export { _store as store };
